import React, {Component} from 'react'
import { compose } from 'redux'
import { Route, Switch, Redirect } from 'react-router'

import * as ROUTES from 'config/routes'
import { PageContent, SideNavigation } from 'components'
import { PageContainer, LinkedSideNavigation, ExportReport, HolderAbsenceReport } from 'smart-components'
import { withClientId } from 'hocs'
import { userIsAuthenticatedRedir } from 'hocs/auth'
import { Spinner } from 'elements'
import { logUserTab } from 'redux/modules/user/index'
import { userSelector } from 'redux/selectors'
import PropTypes from 'prop-types'
import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import Menu from 'antd/lib/menu'

import './index.scss'

// name - used to filter clientId
// key - specifies the path
// label - subtab title
// width - iframe width, in px, for horizontal scroll (optional)
// isReport - displays report export, rather than showing the iframe
// isAttendanceReport - displays attendance report, rather than showing the iframe
const reports = [
  {
    name: 'unifi.unifiid-demo.dashboard.grafana',
    key: '/reports/unifiid-demo/grafana',
    label: 'Grafana',
    icon: 'fund-o',
    isGrafanaDashboard: true,
  },
  {
    name: 'unifi.ucl-som.dashboard.export',
    key: '/reports/ucl-som/export',
    label: 'Export Report',
    isReport: true
  },
  {
    name: 'unifi.air-uni.dashboard.export',
    key: '/reports/air-uni/export',
    label: 'Export Report',
    isReport: true
  },
  {
    name: 'unifi.ict.dashboard.hardware_status',
    key: '/reports/ict/hardware_status',
    label: 'Hardware Status',
    isHardwareDashboard: true
  },
  {
    name: 'unifi.test-club.icad.dashboard.attendance_report',
    key: '/reports/test-club/icad/attendance_report',
    label: 'ICAD Test - Attendance Report',
    isAttendanceReport: true
  },
  {
    name: 'unifi.fora.dashboard.hardware_status',
    key: '/reports/fora/hardware_status',
    label: 'Hardware Status',
    icon: 'fund-o',
    isHardwareDashboard: true
  },
  {
    name: 'unifi.fora.dashboard.grafanavisitmonitoring',
    key: '/reports/fora/grafanavisitmonitoring',
    label: 'Visit Monitoring',
    icon: 'fund-o',
    isforaVisitMonitoringDashboard: true
  },
  {
    name: 'unifi.fora.dashboard.grafanavisitorinformation',
    key: '/reports/fora/grafanavisitorinformation',
    label: 'Visitor Information',
    icon: 'file-search-o',
    isforaVisitorInformationDashboard: true
  },
  {
    name: 'unifi.fora.dashboard.grafanadashboardsplit',
    key: '/reports/fora/grafanadashboardsplit',
    label: 'Dashboard Split',
    icon: 'area-chart-o',
    isforaDashboardSplit: true
  },
  {
    name: 'unifi.fora.dashboard.grafanadashboardaggregate',
    key: '/reports/fora/grafanadashboardaggregate',
    label: 'Dashboard Aggregate',
    icon: 'line-chart-o',
    isforaDashboardAggregate: true
  },
  {
    name: 'unifi.fora.dashboard.grafanamap',
    key: '/reports/fora/grafanamap',
    label: 'Map',
    icon: 'global-o',
    isforaMap: true
  },
  {
    name: 'unifi.fora.dashboard.grafanacameracounting',
    key: '/reports/fora/grafanacameracounting',
    icon: 'camera-o',
    label: 'Camera Counting',
    isforaDashboardCameraCounting: true
  },
  {
    name: 'unifi.groucho.dashboard.grafanavisitmonitoring',
    key: '/reports/groucho/grafanavisitmonitoring',
    icon: 'fund-o',
    label: 'Visit Monitoring',
    isgrouchoVisitMonitoringDashboard: true
  },
  {
    name: 'unifi.groucho.dashboard.grafanavisitorinformation',
    key: '/reports/groucho/grafanavisitorinformation',
    icon: 'file-search-o',
    label: 'Visitor Information',
    isgrouchoVisitorInformationDashboard: true
  },
  {
    name: 'unifi.groucho.dashboard.grafanadashboardaggregate',
    key: '/reports/groucho/grafanadashboardaggregate',
    icon: 'line-chart-o',
    label: 'Dashboard Aggregate',
    isgrouchoDashboardAggregate: true
  },
  {
    name: 'unifi.groucho.dashboard.grafanacameracounting',
    key: '/reports/groucho/grafanacameracounting',
    icon: 'camera-o',
    label: 'Camera Counting',
    isgrouchoCameraCounting: true
  },
  {
    name: 'unifi.groucho.dashboard.grafanapeakoccupancyperhour',
    key: '/reports/groucho/grafanapeakoccupancyperhour',
    icon: 'line-chart-o',
    label: 'Peak Occupancy Per Hour',
    isgrouchoPeakOccupancyPerHour: true
  },
  {
    name: 'unifi.groucho.dashboard.grafanapeakoccupancyperday',
    key: '/reports/groucho/grafanapeakoccupancyperday',
    icon: 'line-chart-o',
    label: 'Peak Occupancy Per Day',
    isgrouchoPeakOccupancyPerDay: true
  },
  {
    name: 'unifi.tsb.dashboard.grafanavisitmonitoring',
    key: '/reports/tsb/grafanavisitmonitoring',
    icon: 'fund-o',
    label: 'Visit Monitoring',
    istsbVisitMonitoringDashboard: true
  },
  {
    name: 'unifi.tsb.dashboard.grafanavisitorinformation',
    key: '/reports/tsb/grafanavisitorinformation',
    icon: 'file-search-o',
    label: 'Visitor Information',
    istsbVisitorInformationDashboard: true
  },
  {
    name: 'unifi.tsb.dashboard.grafanadashboardsplit',
    key: '/reports/tsb/grafanadashboardsplit',
    icon: 'area-chart-o',
    label: 'Dashboard Split',
    istsbDashboardSplit: true
  },
  {
    name: 'unifi.tsb.dashboard.grafanadashboardaggregate',
    key: '/reports/tsb/grafanadashboardaggregate',
    label: 'Dashboard Aggregate',
    icon: 'line-chart-o',
    istsbDashboardAggregate: true
  },
  {
    name: 'unifi.tsb.dashboard.grafanamap',
    key: '/reports/tsb/grafanamap',
    label: 'Map',
    icon: 'global-o',
    istsbMap: true
  },
  // TSB Magnox Reports
  {
    name: 'unifi.tsb.magnox.home',
    key: '/reports/tsb/magnoxhome',
    label: 'Home',
    isMagnoxHome: true
  },
  {
    name: 'unifi.magnox.dashboard.grafanavisitmonitoring',
    key: '/reports/magnox/grafanavisitmonitoring',
    icon: 'fund-o',
    label: 'Visit Monitoring',
    ismagnoxVisitMonitoringDashboard: true
  },
  {
    name: 'unifi.magnox.dashboard.grafanavisitorinformation',
    key: '/reports/magnox/grafanavisitorinformation',
    icon: 'file-search-o',
    label: 'Visitor Information',
    ismagnoxVisitorInformationDashboard: true
  },
  {
    name: 'unifi.magnox.dashboard.grafanadashboardaggregate',
    key: '/reports/magnox/grafanadashboardaggregate',
    icon: 'line-chart-o',
    label: 'Dashboard Aggregate',
    ismagnoxDashboardAggregate: true
  },
  // TSB Gresham Reports
  {
    name: 'unifi.tsb.gresham.home',
    key: '/reports/tsb/greshamhome',
    label: 'Home',
    isGreshamHome: true
  },
  {
    name: 'unifi.gresham.dashboard.grafanavisitmonitoring',
    key: '/reports/gresham/grafanavisitmonitoring',
    icon: 'fund-o',
    label: 'Visit Monitoring',
    isgreshamVisitMonitoringDashboard: true
  },
  {
    name: 'unifi.gresham.dashboard.grafanavisitorinformation',
    key: '/reports/gresham/grafanavisitorinformation',
    icon: 'file-search-o',
    label: 'Visitor Information',
    isgreshamVisitorInformationDashboard: true
  },
  {
    name: 'unifi.gresham.dashboard.grafanadashboardaggregate',
    key: '/reports/gresham/grafanadashboardaggregate',
    icon: 'line-chart-o',
    label: 'Dashboard Aggregate',
    isgreshamDashboardAggregate: true
  },
    // TSB Keypoint Reports
    {
      name: 'unifi.tsb.keypoint.home',
      key: '/reports/tsb/keypointhome',
      label: 'Home',
      isKeypointHome: true
    },
    {
      name: 'unifi.tsb.dashboard.grafanavisitmonitoring',
      key: '/reports/tsb/grafanavisitmonitoring',
      icon: 'fund-o',
      label: 'Visit Monitoring',
      istsbVisitMonitoringDashboard: true
    },
    {
      name: 'unifi.tsb.dashboard.grafanavisitorinformation',
      key: '/reports/tsb/grafanavisitorinformation',
      icon: 'file-search-o',
      label: 'Visitor Information',
      istsbVisitorInformationDashboard: true
    },
    {
      name: 'unifi.tsb.dashboard.grafanadashboardaggregate',
      key: '/reports/tsb/grafanadashboardaggregate',
      icon: 'line-chart-o',
      label: 'Dashboard Aggregate',
      istsbDashboardAggregate: true
    },
  // TAS United Reports
  {
    name: 'unifi.tasu.home',
    key: '/reports/tasu/home',
    label: 'Home',
    isTasuHome: true
  },
  {
    name: 'unifi.tasu.dashboard.grafanavisitmonitoring',
    key: '/reports/tasu/grafanavisitmonitoring',
    icon: 'fund-o',
    label: 'Visit Monitoring',
    isTasuVisitMonitoringDashboard: true
  },
  {
    name: 'unifi.tasu.dashboard.grafanavisitorinformation',
    key: '/reports/tasu/grafanavisitorinformation',
    icon: 'file-search-o',
    label: 'Visitor Information',
    isTasuVisitorInformationDashboard: true
  },
  {
    name: 'unifi.tasu.dashboard.grafanadashboardsplit',
    key: '/reports/tasu/grafanadashboardsplit',
    icon: 'area-chart-o',
    label: 'Dashboard Split',
    isTasuDashboardSplit: true
  },
  {
    name: 'unifi.tasu.dashboard.grafanadashboardaggregate',
    key: '/reports/tasu/grafanadashboardaggregate',
    icon: 'line-chart-o',
    label: 'Dashboard Aggregate',
    isTasuDashboardAggregate: true
  },
  {
    name: 'unifi.tasu.dashboard.grafanamap',
    key: '/reports/tasu/grafanamap',
    label: 'Map',
    isTasuMap: true
  },
  // artfarm grafana reports
  {
    name: 'unifi.artfarm.dashboard.artfarmrealtimeoccupancy',
    key: '/reports/artfarm/artfarmrealtimeoccupancy',
    icon: 'fund-o',
    label: 'Real Time Occupancy',
    isArtfarmRealTimeOccupancy: true
  },
  {
    name: 'unifi.artfarm.dashboard.artfarmcumulativeoccupancysearch',
    key: '/reports/artfarm/artfarmcumulativeoccupancysearch',
    icon: 'file-search-o',
    label: 'Cumulative Occupancy Search',
    isArtfarmCumulativeOccupancySearch: true
  },
  {
    name: 'unifi.artfarm.dashboard.artfarmpeakentriesday',
    key: '/reports/artfarm/artfarmpeakentriesday',
    icon: 'fund-o',
    label: 'Peak Entries per Day',
    isArtfarmPeakEntriesDay: true
  },
  {
    name: 'unifi.artfarm.dashboard.artfarmpeakentrieshour',
    key: '/reports/artfarm/artfarmpeakentrieshour',
    icon: 'fund-o',
    label: 'Peak Entries per Hour',
    isArtfarmPeakEntriesHour: true
  },
  // 25ep Reports
  {
    name: 'unifi.25ep.dashboard.grafanavisitmonitoring',
    key: '/reports/25ep/grafanavisitmonitoring',
    icon: 'fund-o',
    label: 'Visit Monitoring',
    is25epVisitMonitoringDashboard: true
  },
  {
    name: 'unifi.25ep.dashboard.grafanavisitorinformation',
    key: '/reports/25ep/grafanavisitorinformation',
    icon: 'file-search-o',
    label: 'Visitor Information',
    is25epVisitorInformationDashboard: true
  },
  {
    name: 'unifi.25ep.dashboard.grafanadashboardaggregate',
    key: '/reports/25ep/grafanadashboardaggregate',
    icon: 'line-chart-o',
    label: 'Dashboard Aggregate',
    is25epDashboardAggregate: true
  },
  {
    name: 'unifi.25ep.dashboard.grafanacameracounting',
    key: '/reports/25ep/grafanacameracounting',
    label: 'Camera Counting',
    is25epCameraCounting: true
  },
    // Gleneagles Reports
  // {
  //   name: 'unifi.gleneagles.home',
  //   key: '/reports/gleneagles/home',
  //   label: 'Home',
  //   isGleneaglesHome: true
  // },
  {
    name: 'unifi.gleneagles.dashboard.grafanavisitmonitoring',
    key: '/reports/gleneagles/grafanavisitmonitoring',
    icon: 'fund-o',
    label: 'Visit Monitoring',
    isgleneaglesVisitMonitoringDashboard: true
  },
  {
    name: 'unifi.gleneagles.dashboard.grafanavisitorinformation',
    key: '/reports/gleneagles/grafanavisitorinformation',
    icon: 'file-search-o',
    label: 'Visitor Information',
    isgleneaglesVisitorInformationDashboard: true
  },
  {
    name: 'unifi.gleneagles.dashboard.grafanadashboardaggregate',
    key: '/reports/gleneagles/grafanadashboardaggregate',
    icon: 'line-chart-o',
    label: 'Dashboard Aggregate',
    isgleneaglesDashboardAggregate: true
  },
  // Tramp Reports
  {
    name: 'unifi.tramp.dashboard.grafanadashboard',
    key: '/reports/tramp/grafanadashboard',
    icon: 'line-chart-o',
    label: 'Dashboard',
    isTrampDashboard: true
  },
  {
    name: 'unifi.tramp.dashboard.grafanavisitmonitoring',
    key: '/reports/tramp/grafanavisitmonitoring',
    icon: 'fund-o',
    label: 'Visit Monitoring',
    isTrampVisitMonitoring: true
  },
  {
    name: 'unifi.tramp.dashboard.grafanavisitorinformation',
    key: '/reports/tramp/grafanavisitorinformation',
    icon: 'file-search-o',
    label: 'Visitor Information',
    isTrampVisitorInformation: true
  },
  {
    name: 'unifi.tramp.dashboard.grafanacameracounting',
    key: '/reports/tramp/grafanacameracounting',
    icon: 'camera-o',
    label: 'Camera Counting',
    isTrampCameraCounting: true
  },
  // Sloane Reports
  {
    name: 'unifi.sloane.dashboard.grafanadashboard',
    key: '/reports/sloane/grafanadashboard',
    icon: 'line-chart-o',
    label: 'Dashboard',
    isSloaneDashboard: true
  },
  {
    name: 'unifi.sloane.dashboard.grafanavisitmonitoring',
    key: '/reports/sloane/grafanavisitmonitoring',
    icon: 'fund-o',
    label: 'Visit Monitoring',
    isSloaneVisitMonitoring: true
  },
  {
    name: 'unifi.sloane.dashboard.grafanavisitorinformation',
    key: '/reports/sloane/grafanavisitorinformation',
    icon: 'file-search-o',
    label: 'Visitor Information',
    isSloaneVisitorInformation: true
  },
  {
    name: 'unifi.sloane.dashboard.grafanacameracounting',
    key: '/reports/sloane/grafanacameracounting',
    icon: 'camera-o',
    label: 'Camera Counting',
    isSloaneCameraCounting: true
  },
  // TDS Reports
  {
    name: 'unifi.tds.dashboard.grafanadashboardaggregate',
    key: '/reports/tds/grafanadashboardaggregate',
    icon: 'line-chart-o',
    label: 'Dashboard Aggregate',
    isTDSDashboardAggregate: true
  },
  {
    name: 'unifi.tds.dashboard.grafanadashboardsplit',
    key: '/reports/tds/grafanadashboardsplit',
    icon: 'area-chart-o',
    label: 'Dashboard Split',
    isTDSDashboardSplit: true
  },
  {
    name: 'unifi.tds.dashboard.grafanavisitmonitoring',
    key: '/reports/tds/grafanavisitmonitoring',
    icon: 'fund-o',
    label: 'Visit Monitoring',
    isTDSVisitMonitoring: true
  },
  {
    name: 'unifi.tds.dashboard.grafanavisitorinformation',
    key: '/reports/tds/grafanavisitorinformation',
    icon: 'file-search-o',
    label: 'Visitor Information',
    isTDSVisitorInformation: true
  }
]

class Reports extends Component {

  static propTypes = {
    logUserTab: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props)
    this.mobileWidth = 0
    this.state = {
      reportsList: [],
      width: window.innerWidth,
      iFrameLoading: true,
    }
  }

  componentWillMount() {
    this.setState({ reportsList: this.filterReportsByClientId(this.props.clientId) })
    window.addEventListener('resize', this.handleWindowSizeChange)
  }
  componentDidMount() {
    const { clientId,logUserTab} = this.props
    const tab = "Reports"
    logUserTab({ clientId, tab})
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  }

  clearLoadIFrame = () => {
    this.setState({iFrameLoading: false})
  }

  filterReportsByClientId = (clientId) => reports.filter( report => report.name.split('.')[1] === clientId )

  hardwareDashboard = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://my.appoptics.com/s/public/8tkp74qdo'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  grafanaDashboard = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.groucho.viewer.unifi-id.click/d/mxdOeec4z/groucho-viewer-dashboard'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  //tasu
  tasuVisitMonitoringDashboard = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.tasu.viewer.unifi-id.click/d/bf3iwufb/tasu-visit-monitoring'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  tasuVisitorInformation = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.tasu.viewer.unifi-id.click/d/WtmavBxVk/tasu-visitor-information'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  tasuDashboardSplit = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.tasu.viewer.unifi-id.click/d/XjeRvfb4z/tasu-viewer-dashboard-split'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  tasuDashboardAggregate = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.tasu.viewer.unifi-id.click/d/iTmjNfb4z/tasu-viewer-dashboard-aggregate'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  tasuMap = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.tasu.viewer.unifi-id.click/d/kFm9ax-Vkfdfasd/map?orgId=3&refresh=1d'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  //artfarm
  artfarmRealTimeOccupancy = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.groucho.viewer.unifi-id.click/d/VSvYLrfIk/artfarm-real-time-occupancy'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  artfarmCumulativeOccupancySearch = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.groucho.viewer.unifi-id.click/d/VSvYLrfIksaddsa/cumulative-occupancy-search'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )
  
  artfarmPeakEntriesDay = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.groucho.viewer.unifi-id.click/d/iTmjNfb4zKJGILUGdszfwrhgaasdqdw/peak-entries-per-day'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  artfarmPeakEntriesHour = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.groucho.viewer.unifi-id.click/d/iTmjNfb4zKJGILUGdszfwrhgaasdqdwfasegf/peak-entries-per-hour'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )
  //25ep
  ep25VisitMonitoringDashboard = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.25ep.viewer.unifi-id.click/d/25EP-VIS-MON/25ep-visit-monitoring'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  ep25VisitorInformation = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.25ep.viewer.unifi-id.click/d/25EP-VIS-INFO/25ep-visitor-information'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  ep25DashboardAggregate = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.25ep.viewer.unifi-id.click/d/25EP-DASH-AGGR/25ep-viewer-dashboard-aggregate'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  ep25CountingCamera = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.25ep.viewer.unifi-id.click/d/UTpCfQfVk/camera-counting?orgId=3&refresh=15m'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  //gleneagles
  gleneaglesVisitMonitoringDashboard = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.gleneagles.viewer.unifi-id.click/d/GLEN-VIS-MON/gleneagles-visit-monitoring'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  gleneaglesVisitorInformation = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.gleneagles.viewer.unifi-id.click/d/GLEN-VIS-INFO/gleneagles-visitor-information'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  gleneaglesDashboardAggregate = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.gleneagles.viewer.unifi-id.click/d/GLEN-DASH-AGGR/gleneagles-viewer-dashboard-aggregate'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  //tramp
  trampDashboard = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.tramp.viewer.unifi-id.click/d/Tramp-Dashboard/dashboard'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  trampVisitMonitoring = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.tramp.viewer.unifi-id.click/d/Tramp-Visit-Monitoring/visit-monitoring'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  trampVisitorInformation = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.tramp.viewer.unifi-id.click/d/Tramp-Visit-Info/visitor-information'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  trampCameraCounting = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.tramp.viewer.unifi-id.click/d/Camera-Counting/camera-counting'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  //sloane
  sloaneDashboard = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.25ep.viewer.unifi-id.click/d/SLOANE-DASH-AGGR/dashboard'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  sloaneVisitMonitoring = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.25ep.viewer.unifi-id.click/d/SLOANE-VIS-MON/visit-monitoring'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  sloaneVisitorInformation = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.25ep.viewer.unifi-id.click/d/SLOANE-VIS-INFO/visitor-information'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  sloaneCameraCounting = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.25ep.viewer.unifi-id.click/d/UTpCfQfVkehr6safwedf/camera-counting'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  //TDS
  tdsDashboardAggregate = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.tds.viewer.unifi-id.click/d/Si-u-x-4kxac/dashboard-aggregate'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  tdsDashboardSplit = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.tds.viewer.unifi-id.click/d/kFm9ax-Vkwqdqwd/dashboard-split'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  tdsVisitMonitoring = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.tds.viewer.unifi-id.click/d/aswfqwe3ggewg/visit-monitoring'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  tdsVisitorInformation = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.tds.viewer.unifi-id.click/d/ajfhbpqoi8hefvwpdskf/visitor-information'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  //gresham
  greshamVisitMonitoringDashboard = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.gresham.viewer.unifi-id.click/d/GRESHAM-VIS-MON/gresham-visit-monitoring'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  greshamVisitorInformation = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.gresham.viewer.unifi-id.click/d/GRESHAM-VIS-INFO/gresham-visitor-information'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  greshamDashboardAggregate = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.gresham.viewer.unifi-id.click/d/GRESHAM-DASH-AGGR/gresham-viewer-dashboard-aggregate'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  //groucho
  grouchoVisitMonitoringDashboard = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.groucho.viewer.unifi-id.click/d/GROUCHO-VIS-MON/groucho-visit-monitoring'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  grouchoVisitorInformation = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.groucho.viewer.unifi-id.click/d/GROUCHO-VIS-INFO/groucho-visitor-information'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  grouchoDashboardAggregate = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.groucho.viewer.unifi-id.click/d/GROUCHO-DASH-AGGR/groucho-viewer-dashboard-aggregate'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  grouchoCameraCounting = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.groucho.viewer.unifi-id.click/d/UTpCfQfVkehr6/camera-counting'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  grouchoPeakOccupancyPerHour = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.groucho.viewer.unifi-id.click/d/iTmjNfb4zKJGILUGd/occupancy-per-hour'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  grouchoPeakOccupancyPerDay = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.groucho.viewer.unifi-id.click/d/iTmjNfb4zKJGILUGdszfwrhgaa/peak-occupancy-per-day'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  //keypoint
  keypointVisitMonitoringDashboard = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.keypoint.viewer.unifi-id.click/d/TSB-KEYPOINT-VIS-MON/keypoint-visit-monitoring'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  keypointVisitorInformation = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.keypoint.viewer.unifi-id.click/d/TSB-KEYPOINT-VIS-INFO/keypoint-visitor-information'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  keypointDashboardAggregate = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.keypoint.viewer.unifi-id.click/d/TSB-KEYPOINT-DASH-AGGR/keypoint-viewer-dashboard-aggregate'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  //magnox
  magnoxVisitMonitoringDashboard = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.magnox.viewer.unifi-id.click/d/MAGNOX-VIS-MON/magnox-visit-monitoring'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  magnoxVisitorInformation = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.magnox.viewer.unifi-id.click/d/MAGNOX-VIS-INFO/magnox-visitor-information'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  magnoxDashboardAggregate = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.magnox.viewer.unifi-id.click/d/MAGNOX-DASH-AGGR/magnox-viewer-dashboard-aggregate'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  //tsb
  tsbVisitMonitoringDashboard = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.tsb.viewer.unifi-id.click/d/TSB-VIS-MON/tsb-visit-monitoring'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  tsbVisitorInformation = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.tsb.viewer.unifi-id.click/d/TSB-VIS-INFO/tsb-visitor-information'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  tsbDashboardSplit = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.tsb.viewer.unifi-id.click/d/TSB-DASH-SPLT/tsb-viewer-dashboard-split'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  tsbDashboardAggregate = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.tsb.viewer.unifi-id.click/d/TSB-DASH-AGGR/tsb-viewer-dashboard-aggregate'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  tsbMap = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.tsb.viewer.unifi-id.click/d/kFm9ax-VkfdfAS/map?orgId=3&refresh=1d'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  //fora
  foraVisitMonitoringDashboard = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.fora.viewer.unifi-id.click/d/lGMa-b-4k/fora-visit-monitoring'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  foraVisitorInformation = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.fora.viewer.unifi-id.click/d/p9Wy-baVk/fora-visitor-information'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  foraDashboardSplit = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.fora.viewer.unifi-id.click/d/kFm9ax-Vk/fora-viewer-dashboard-split'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  foraDashboardAggregate = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.fora.viewer.unifi-id.click/d/Si-u-x-4k/fora-viewer-dashboard-aggregate'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  foraCameraCounting = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.fora.viewer.unifi-id.click/d/x1_FEOPVz/fora-camera-counting'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  foraMap = ({ dashboardWidth }) => (
    <div className={dashboardWidth && 'dashboard__overflow'}>
      <div className={'iframe__container ' + {dashboardWidth}} style={{width: dashboardWidth && dashboardWidth + 'px'}} >
        {this.state.iFrameLoading && <div className="pre-loader"><Spinner /></div>}
        <iframe src={'https://grafana.fora.viewer.unifi-id.click/d/kFm9ax-Vkfdfcssa/map?orgId=3&refresh=2h'} style={{width: dashboardWidth && dashboardWidth + 'px'}} onLoad={this.clearLoadIFrame}/>
      </div>
    </div>
  )

  guessDashboardType = (width) => {
    let type = 'published_link_desktop'

    if (width <= this.mobileWidth)
      type = 'published_link_mobile'

    return type
  }

  render() {
    const { reportsList, width, iFrameLoading } = this.state
    const { user } = this.props
    const operator = user && user.currentUser && user.currentUser.operator
    let filteredReports = reportsList
    
    // filter by operator
    if(operator.username === "MGX-Kirstee" && operator.clientId === "tsb"){
      filteredReports = reportsList.filter(report => report.name.includes("magnox"))
    } else if(operator.username === "unifi" && operator.clientId === "tsb") {
      filteredReports = reportsList.filter(report => report.name.includes("magnox"))
    } else if(operator.username === "KassimJaiyesimi" && operator.clientId === "tsb") {
      filteredReports = reportsList.filter(report => report.name.includes("gresham"))
    } else if(operator.username === "LauraThomas" && operator.clientId === "tsb") {
      filteredReports = reportsList.filter(report => report.name.includes("keypoint"))
    } else {
      filteredReports = reportsList.filter(report => !report.name.includes("magnox") 
      && !report.name.includes("gresham") && !report.name.includes("keypoint"))
    }
    const dashboardType = this.guessDashboardType(width)

    return (
      <PageContainer className="reports__page">
        <PageContent>
          {/* <PageContent.Sidebar> */}
          <div>
            <div className="float-navigation">

            <LinkedSideNavigation
              menus={filteredReports} />
              </div>
          {/* </PageContent.Sidebar> */}
          <div className="float-reports">
          {/* <PageContent.Main> */}
            {
              filteredReports.length > 0 && (
                <Switch>
                  <Redirect exact from={ROUTES.REPORTS} to={filteredReports[0].key} />
                    {
                      filteredReports.map( (dashboard, index) =>{
                        if(dashboard.isReport){
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <ExportReport />}
                            />
                          )
                        } else if (dashboard.isAttendanceReport) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <HolderAbsenceReport />}
                            />
                          )
                        } else if (dashboard.isHardwareDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.hardwareDashboard dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isGrafanaDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.grafanaDashboard dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isTasuVisitMonitoringDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.tasuVisitMonitoringDashboard dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isTasuVisitorInformationDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.tasuVisitorInformation dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isTasuDashboardSplit) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.tasuDashboardSplit dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isTasuDashboardAggregate) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.tasuDashboardAggregate dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isTasuMap) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.tasuMap dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isArtfarmRealTimeOccupancy) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.artfarmRealTimeOccupancy dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isArtfarmCumulativeOccupancySearch) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.artfarmCumulativeOccupancySearch dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isArtfarmPeakEntriesDay) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.artfarmPeakEntriesDay dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isArtfarmPeakEntriesHour) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.artfarmPeakEntriesHour dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.is25epVisitMonitoringDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.ep25VisitMonitoringDashboard dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.is25epVisitorInformationDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.ep25VisitorInformation dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.is25epDashboardAggregate) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.ep25DashboardAggregate dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.is25epCameraCounting) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.ep25CountingCamera dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isgleneaglesVisitMonitoringDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.gleneaglesVisitMonitoringDashboard dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isgleneaglesVisitorInformationDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.gleneaglesVisitorInformation dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isgleneaglesDashboardAggregate) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.gleneaglesDashboardAggregate dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isgreshamVisitMonitoringDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.greshamVisitMonitoringDashboard dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isgreshamVisitorInformationDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.greshamVisitorInformation dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isgreshamDashboardAggregate) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.greshamDashboardAggregate dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isgrouchoVisitMonitoringDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.grouchoVisitMonitoringDashboard dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isgrouchoVisitorInformationDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.grouchoVisitorInformation dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isgrouchoDashboardAggregate) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.grouchoDashboardAggregate dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isgrouchoCameraCounting) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.grouchoCameraCounting dashboardWidth={dashboard.width} />}
                            />
                          )
                        }
                        else if (dashboard.isgrouchoPeakOccupancyPerHour) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.grouchoPeakOccupancyPerHour dashboardWidth={dashboard.width} />}
                            />
                          )
                        }
                        else if (dashboard.isgrouchoPeakOccupancyPerDay) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.grouchoPeakOccupancyPerDay dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.iskeypointVisitMonitoringDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.keypointVisitMonitoringDashboard dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.iskeypointVisitorInformationDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.keypointVisitorInformation dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.iskeypointDashboardAggregate) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.keypointDashboardAggregate dashboardWidth={dashboard.width} />}
                            />
                          )
                        }  else if (dashboard.isTrampDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.trampDashboard dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isTrampVisitMonitoring) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.trampVisitMonitoring dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isTrampVisitorInformation) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.trampVisitorInformation dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isTrampCameraCounting) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.trampCameraCounting dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isSloaneDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.sloaneDashboard dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isSloaneVisitMonitoring) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.sloaneVisitMonitoring dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isSloaneVisitorInformation) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.sloaneVisitorInformation dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isSloaneCameraCounting) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.sloaneCameraCounting dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isTDSDashboardAggregate) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.tdsDashboardAggregate dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isTDSDashboardSplit) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.tdsDashboardSplit dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isTDSVisitMonitoring) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.tdsVisitMonitoring dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isTDSVisitorInformation) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.tdsVisitorInformation dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.ismagnoxVisitMonitoringDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.magnoxVisitMonitoringDashboard dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.ismagnoxVisitorInformationDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.magnoxVisitorInformation dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.ismagnoxDashboardAggregate) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.magnoxDashboardAggregate dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.istsbVisitMonitoringDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.tsbVisitMonitoringDashboard dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.istsbVisitorInformationDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.tsbVisitorInformation dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.istsbDashboardSplit) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.tsbDashboardSplit dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.istsbDashboardAggregate) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.tsbDashboardAggregate dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.istsbMap) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.tsbMap dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isforaVisitMonitoringDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.foraVisitMonitoringDashboard dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isforaVisitorInformationDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.foraVisitorInformation dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isforaDashboardSplit) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.foraDashboardSplit dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isforaDashboardAggregate) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.foraDashboardAggregate dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isforaMap) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.foraMap dashboardWidth={dashboard.width} />}
                            />
                          )
                        } else if (dashboard.isforaDashboardCameraCounting) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <this.foraCameraCounting dashboardWidth={dashboard.width} />}
                            />
                          )
                        }  else if (dashboard.isClarendonDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = clarendonDashboard}
                            />
                          )
                        } else if (dashboard.isClarendonVisitorQuery) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = clarendonVisitorQuery}
                            />
                          )
                        } else if (dashboard.isClarendonVisitorList) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = clarendonVisitorList}
                            />
                          )
                        } else if (dashboard.isClarendonCompanyQuery) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = clarendonCompanyQuery}
                            />
                          )
                        } else if (dashboard.isClarendonMap) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = clarendonMap}
                            />
                          )
                        } else if (dashboard.isClarendonVisitAnalysis) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = clarendonVisitAnalysis}
                            />
                          )
                        } else if (dashboard.isGrouchoDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = grouchoDashboard}
                            />
                          )
                        } else if (dashboard.isGrouchoVisitorQuery) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = grouchoVisitorQuery}
                            />
                          )
                        } else if (dashboard.isGrouchoVisitorList) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = grouchoVisitorList}
                            />
                          )
                        } else if (dashboard.isGrouchoSaasCharges) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = grouchoSaasCharges}
                            />
                          )
                        } else if (dashboard.isGrouchoMap) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = grouchoMap}
                            />
                          )
                        } else if (dashboard.isGrouchoVisitAnalysis) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = grouchoVisitAnalysis}
                            />
                          )
                        } else if (dashboard.isTsbDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbDashboard}
                            />
                          )
                        } else if (dashboard.isTsbVisitorQuery) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbVisitorQuery}
                            />
                          )
                        } else if (dashboard.isTsbVisitorList) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbVisitorList}
                            />
                          )
                        } else if (dashboard.isTsbFunctionQuery) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbFunctionQuery}
                            />
                          )
                        } else if (dashboard.isTsbMap) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbMap}
                            />
                          )
                        } else if (dashboard.isTsbVisitAnalysis) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbVisitAnalysis}
                            />
                          )
                        } else if (dashboard.isTasuHome) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <h2>Please select a report</h2>}
                            />
                          )
                        } else if (dashboard.isTasuCompanyQuery) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tasuCompanyQuery}
                            />
                          )
                        } else if (dashboard.isTasuDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tasuDashboard}
                            />
                          )
                        } else if (dashboard.isTasuVisitorQuery) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tasuVisitorQuery}
                            />
                          )
                        } else if (dashboard.isTasuVisitorList) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tasuVisitorList}
                            />
                          )
                        } else if (dashboard.isTasuSaasCharges) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tasuSaasCharges}
                            />
                          )
                        } else if (dashboard.isTasuMap) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tasuMap}
                            />
                          )
                        } else if (dashboard.isTasuVisitAnalysis) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tasuVisitAnalysis}
                            />
                          )
                        // } else if (dashboard.isGleneaglesHome) {
                        //   return (
                        //     <Route
                        //       key={index}
                        //       path={dashboard.key}
                        //       render={() => <h2>Please select a report</h2>}
                        //     />
                        //   )
                        } else if (dashboard.isGleneaglesCompanyQuery) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = gleneaglesCompanyQuery}
                            />
                          )
                        } else if (dashboard.isGleneaglesDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = gleneaglesDashboard}
                            />
                          )
                        } else if (dashboard.isGleneaglesVisitorQuery) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = gleneaglesVisitorQuery}
                            />
                          )
                        } else if (dashboard.isGleneaglesVisitorList) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = gleneaglesVisitorList}
                            />
                          )
                        } else if (dashboard.isGleneaglesMap) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = gleneaglesMap}
                            />
                          )
                        } else if (dashboard.isGleneaglesVisitAnalysis) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = gleneaglesVisitAnalysis}
                            />
                          )
                        } else if (dashboard.is25epCameraCounting) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = ep25CameraCounting}
                            />
                          )
                        } else if (dashboard.is25epDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = ep25Dashboard}
                            />
                          )
                        } else if (dashboard.is25epVisitorQuery) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = ep25VisitorQuery}
                            />
                          )
                        } else if (dashboard.is25epVisitorList) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = ep25VisitorList}
                            />
                          )
                        } else if (dashboard.is25epCompanyQuery) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = ep25CompanyQuery}
                            />
                          )
                        } else if (dashboard.is25epMap) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = ep25Map}
                            />
                          )
                        } else if (dashboard.is25epVisitAnalysis) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = ep25VisitAnalysis}
                            />
                          )
                        } else if (dashboard.isMagnoxHome) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <h2>Please select a report</h2>}
                            />
                          )
                        } else if (dashboard.isMagnoxDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbMagnoxDashboard}
                            />
                          )
                        } else if (dashboard.isMagnoxVisitorQuery) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbMagnoxVisitorQuery}
                            />
                          )
                        } else if (dashboard.isMagnoxVisitorList) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbMagnoxVisitorList}
                            />
                          )
                        } else if (dashboard.isMagnoxMap) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbMagnoxMap}
                            />
                          )
                        } else if (dashboard.isMagnoxVisitAnalysis) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbMagnoxVisitAnalysis}
                            />
                          )
                        } else if (dashboard.isGreshamHome) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <h2>Please select a report</h2>}
                            />
                          )
                        } else if (dashboard.isGreshamDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbGreshamDashboard}
                            />
                          )
                        } else if (dashboard.isGreshamVisitorQuery) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbGreshamVisitorQuery}
                            />
                          )
                        } else if (dashboard.isGreshamVisitorList) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbGreshamVisitorList}
                            />
                          )
                        } else if (dashboard.isGreshamFunctionQuery) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbGreshamFunctionQuery}
                            />
                          )
                        } else if (dashboard.isGreshamMap) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbGreshamMap}
                            />
                          )
                        } else if (dashboard.isGreshamVisitAnalysis) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbGreshamVisitAnalysis}
                            />
                          )
                        } else if (dashboard.isKeypointHome) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => <h2>Please select a report</h2>}
                            />
                          )
                        } else if (dashboard.isKeypointDashboard) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbKeypointDashboard}
                            />
                          )
                        } else if (dashboard.isKeypointVisitorQuery) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbKeypointVisitorQuery}
                            />
                          )
                        } else if (dashboard.isKeypointVisitorList) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbKeypointVisitorList}
                            />
                          )
                        } else if (dashboard.isKeypointFunctionQuery) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbKeypointFunctionQuery}
                            />
                          )
                        } else if (dashboard.isKeypointMap) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbKeypointMap}
                            />
                          )
                        } else if (dashboard.isKeypointVisitAnalysis) {
                          return (
                            <Route
                              key={index}
                              path={dashboard.key}
                              render={() => window.location.href = tsbKeypointVisitAnalysis}
                            />
                          )
                        }
                        }
                      )
                    }
                </Switch>
              )
            }
          {/* </PageContent.Main> */}
          </div>
          </div>
        </PageContent>
      </PageContainer>
    )
  }
}

export const selector = createStructuredSelector({
  user: userSelector
})

export const actions = {
  logUserTab
}

export default compose(
  userIsAuthenticatedRedir,
  withClientId,
  connect(selector, actions)
)(Reports)



// WEBPACK FOOTER //
// ./src/pages/reports/index.js